export const MVC_VSE_DOMAIN = 'marriottvacationclub.com';
export const MVC_TYPE = 'MVC';
export const VCAP_DOMAIN = 'vacationclubap.com';
export const VSE_TYPE = 'VSE';
export const formatDate = (date: { getFullYear: () => any; getMonth: () => number; getDate: () => any; }) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
}
export const getDomainName = (url: string) => {
    const parts = url.split('.');
    if (parts.length > 2) {
        return parts.slice(-2).join('.');
    }
    return url;
}
export const formatNumber = (num: { toString: () => string; }) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
}